export const getLanguageName = (code: string, displayLocale = code) =>
  new Intl.DisplayNames([displayLocale.replaceAll('_', '-')], {
    type: 'language'
  }).of(code.replaceAll('_', '-')) ?? code;
